export default "__VITE_ASSET__cAPfT6BM__"